module.exports = __webpack_public_path__ + "static/img/83_Easter_eggs.bb33fe91.jpg";